export const MANIFEST_LOADED = 'manifest_loaded';

export const TRACKS_CHANGED = 'tracks_changed';

export const AUDIO_TRACK_CHANGED = 'audio_track_changed';

export const SUBTITLES_TRACK_CHANGED = 'subtitles_track_changed';

export const SUBTITLES_UPDATED = 'subtitles_updated';

export const LICENSE_LOADED = 'license';

export const PLAYER_INFO = 'player_info';
